import { render, staticRenderFns } from "./my-dialog.vue?vue&type=template&id=1d088206&scoped=true&"
import script from "./my-dialog.vue?vue&type=script&lang=js&"
export * from "./my-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d088206",
  null
  
)

export default component.exports